"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  item: {
    background: theme.palette.background.light,
    gap: theme.spacing(2)
  },
  link: {
    color: "inherit"
  },
  imageRoot: {
    flex: "0 0 100px",
    position: "relative"
  },
  timeRoot: {
    display: "flex",
    flexDirection: "column",
    placeContent: "center",
    padding: theme.spacing(0, 2, 0, 0),
    position: "relative",
    textAlign: "center",
    "&::after": {
      background: theme.palette.primary.main,
      content: "''",
      height: 40,
      position: "absolute",
      right: 0,
      top: "50%",
      transform: "translate(0, -50%)",
      width: 1
    }
  },
  timeFrom: {
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightBold
  },
  timeTo: {
    fontWeight: theme.typography.fontWeightBold
  },
  title: {
    color: theme.palette.grey[800],
    flex: 1,
    fontWeight: 700,
    hyphens: "auto",
    placeSelf: "center",
    wordBreak: "break-word"
  },
  noTime: {
    padding: theme.spacing(0, 2)
  },
  notLoaded: {
    display: "none"
  }
}));
const TeaserItem = _ref => {
  let {
    title,
    imageObj,
    timeFrom,
    timeTo,
    pageName
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: css.link,
    to: pageName
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.item,
    container: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.imageRoot
  }, /*#__PURE__*/_react.default.createElement(_image.default, {
    filename: (imageObj === null || imageObj === void 0 ? void 0 : imageObj.filename) && ((imageObj === null || imageObj === void 0 ? void 0 : imageObj.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + (imageObj === null || imageObj === void 0 ? void 0 : imageObj.filename),
    height: 100,
    width: 100,
    alt: "",
    fixed: true
  })), timeFrom && timeTo && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.timeRoot
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    className: css.timeFrom
  }, timeFrom), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    className: css.timeTo
  }, timeTo)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)({
      [css.title]: true,
      [css.noTime]: !timeFrom && !timeTo
    })
  }, title))));
};
var _default = exports.default = TeaserItem;